import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ index, label, dark = true }) => (
  <div
    className={`flex items-center gap-3 font-mono-x text-[11px] sm:text-xs font-medium uppercase tracking-[0.3em] ${
      dark ? "text-[#4C8F2F]" : "text-teal-700"
    }`}
  >
    <span className={dark ? "text-amber-500" : "text-amber-600"}>{index}</span>
    <span className={`h-px w-10 ${dark ? "bg-[#5FA832]/40" : "bg-teal-700/40"}`} />
    <span>{label}</span>
  </div>
);
